import { render } from "./IntellifloOfficeClientForm.vue?vue&type=template&id=6cf98f1e&scoped=true"
import script from "./IntellifloOfficeClientForm.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficeClientForm.vue?vue&type=script&lang=js"

import "./IntellifloOfficeClientForm.vue?vue&type=style&index=0&id=6cf98f1e&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf98f1e"]])

export default __exports__